import React from "react"

interface RecommendationAcceptedInfoProps {
  acceptedDateTime: string
  acceptedVia: string
}
export const RecommendationAcceptedInfo = ({
  acceptedDateTime,
  acceptedVia,
}: RecommendationAcceptedInfoProps) => {
  const recommendationAcceptedDateTime = acceptedDateTime
    ? new Date(acceptedDateTime)
        ?.toLocaleString("en-US", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          hour12: false,
        })
        .replace(/,/g, "")
    : null

  const acceptedViaEnum = {
    MY_MOJO: "My Mojo",
    VERBALLY: "Verbally",
    SMS: "SMS",
    EMAIL: "Email",
  }

  // acceptance requires salesforce data via a page refresh or another query setup
  const clientsideDate = new Date()?.toLocaleString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: false,
  })

  const formattedVia = acceptedVia ? acceptedVia?.toLowerCase() : null
  return (
    <div>
      <>
        Accepted{" "}
        {(acceptedVia === acceptedViaEnum.SMS || acceptedVia === acceptedViaEnum.EMAIL) &&
          `via ${formattedVia} `}
        {acceptedVia === acceptedViaEnum.VERBALLY && "over the phone "}
        {!recommendationAcceptedDateTime && clientsideDate}
      </>
      {!!recommendationAcceptedDateTime && recommendationAcceptedDateTime}
    </div>
  )
}
